const state = () => ({
  name: 'index'
})

const getters = {
  getName(state, getters, rootState) {
    return {
      name: state.name
    }
  },
}
const mutations = {
  changeLan (state, payload = 'index') {
    state.name = payload
  }
}
const actions = {
  getUserInfo({ commit, state }, products) {
    
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}